export const ESTUDIOS_BASE_OBJ = {
  ESTUDIOS: {
    children: [{ // EJEMPLO
        children: [{},
          {
            id: 'MmKoqqwyf7pekRa4hCz2',
            delete: false,
            name: 'estudio',
            name_nivel1: 'Especie',
            id_nivel1: 'a164316b-1b2b-4fd7-b94a',
            nivel: 2
          }
        ],
        delete: false,
        id: 'a164316b-1b2b-4fd7-b94a',
        name: 'Especie',
        nivel: 1
      },

    ],
    name: "Estudios",
    version: "1.0",
  },
  ESTUDIO: {
    items: [{
      invervalos: {
        max: "4",
        min: "3"
      },
      nombre: "nombre",
      unidad: "g/L"
    }],
    delete: false,
    especie: "Canino",
    nombre: "Estudio",
    precio: "00",
    compartir: {
      es_publico: true,
      en_sucursales: {},
    },
    estatus: {
      fecha_baja: {},
      activo: 'activo',
    },
    servicio_padre: "",
  }
}


export const ESTUDIO_BASE_OBJ = {
  nombre: '',
  especie: '',
  precio: 0,
  items: [],
  delete: false,
  unidad: '',
  sucursal: [],
  servicio_padre: '',
  compartir: {
    es_publico: true,
    en_sucursales: {}
  },
  estatus: {
    fecha_baja: {},
    activo: 'activo',
  },
  info: {
    fecha_alta: '',
    fecha_nacimiento: '',
  },
  motivosBaja: '',
}

export const UNIDADES_BASE_OBJ = ["L/L", "g/L"]

export const FIELDS_BASE_OBJ = [{
    key: "nombre",
    label: "Nombre"
  }, {
    key: "unidades",
    label: "Unidades"
  },
  {
    key: "intervalos",
    label: "Intervalos"
  }, {
    key: "eliminar",
    label: "Eliminar"
  }
]

export const DATA_BASE_OBJ = {
  estudioNameSeleccionado: '',
  estudioSeleccionado_lv1: '',
  estudioSeleccionado_lv2: '',
  estudioIdLv1Seleccionado: '',
  estudioIdLv2Seleccionado: '',
  estudioNivelSeleccionado: ''
}



// WEBPACK FOOTER //
// ./src/constantes/estudios.js